export default "/assets/website/images/factory-and-werehouse.jpg?2baa305ca661c3a65e9031bf8558946b";